import { httpCreators, HttpResponse } from '@ppvrbh/merchant-frontend-core';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { branchCreators } from './branch-action';
import { BRANCH_STATE_KEY } from './branch-reducer';
import { BRANCH_ACTION_TYPE } from './branch-type';
import { BRANCH_REQUEST_ID_LIST } from './branch-constant';
import { BranchService } from './branch-service';
import { generalCreators } from '../../../../redux/general/general-action';
import { MODAL_TYPE } from '../../../../redux/general/general-constant';
import { GENERAL_STATE_KEY } from '../../../../redux/general/general-reducer';
import { generalSagas } from '../../../../redux/general/general-saga';
import { RootState } from '../../../../redux/root-reducer';
import { noop } from 'lodash';
import { LocationDetail } from '../../../../shared/models/location';

function* callBranch() {
  yield put(httpCreators.request({
    id: BRANCH_REQUEST_ID_LIST.GET_BRANCH,
    sagaHandler: getBranchHandler as any,
    callbackParams: '',
    service: BranchService.getBranch,
    serviceParams: ''
  }));
  yield call(generalSagas.callTnc);
}

function* getBranchHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield put(branchCreators.setBranchState(BRANCH_STATE_KEY.BRANCH_LIST, resp.data.shops as []));
  } else {
    yield put(branchCreators.setBranchState(BRANCH_STATE_KEY.BRANCH_LIST, undefined));
  }
}


function* addBranchHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield call(callbackParams);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* editBranchHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield call(callbackParams);
  } else if (resp.statusCode === 1899 && resp.data?.translationKey === 'shop.temporaryClose.timePeriodInvalid') {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalContent: 'main.branchtable.statusshop.invalidtime',
      type: MODAL_TYPE.ERROR
    }));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* deleteBranchHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield call(callbackParams);
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: noop,
      type: MODAL_TYPE.ERROR
    }));
  }
}

function getBranchList(state: RootState) {
  return state.branch.branch_list;
}

function* getVatHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield put(branchCreators.setBranchState(BRANCH_STATE_KEY.VAT_LIST, resp.data.vatAddresses as []));
    const branchData = yield select(getBranchList);
    const defaultFlag = resp.data.vatAddresses[0].vatAddressId;
    const shopArray = new Array();
    branchData.map((b: any) => {
     return shopArray.push({
       shopId: b.shopId,
       vatAddressId: b.vatAddressId ? b.vatAddressId : defaultFlag
     });
    });
    yield put(branchCreators.setBranchState(BRANCH_STATE_KEY.MAPPING_LIST, shopArray as []));
    callbackParams();
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => {
        callbackParams();
      },
      type: MODAL_TYPE.ERROR
    }));
  }
}

function* getLocationHandler(resp: HttpResponse, callbackParams: (location: LocationDetail) => void) {
  if (resp.success && resp.data?.location) {
    yield call(callbackParams, resp.data.location);
  }
}

function* mappingBranchVatHandler(resp: HttpResponse, callbackParams: any) {
  if (resp.success) {
    yield call(callbackParams?.pushToBranch);
    yield put(branchCreators.setBranchState(BRANCH_STATE_KEY.ALERT_SUCCESS, true));
  } else {
    yield put(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      onOk: () => {
        callbackParams.pushToBranch();
        callbackParams.mappingFail();
      },
      type: MODAL_TYPE.ERROR
    }));
  }
}
export const branchSagas = {
  callBranch,
  getVatHandler,
  getBranchList,
  getBranchHandler,
  deleteBranchHandler,
  addBranchHandler,
  editBranchHandler,
  mappingBranchVatHandler,
  getLocationHandler,
  watchers: [
    takeLatest(BRANCH_ACTION_TYPE.CALL_BRANCH, callBranch),
  ]
};
